import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import openConfirmEmailModal from '@/modules/_helpers/openConfirmEmailModal'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 12px',
    borderRadius: theme.borderRadius,
    background: theme.palette.warning.background,
    color: theme.palette.warning.contrastText,
    fontSize: theme.fontSizes.small,
    lineHeight: 1.3,
    '& a': {
      color: theme.primaryV2,
      cursor: 'pointer',
      marginLeft: 4,
      whiteSpace: 'nowrap',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}))

interface IEmailNotConfirmedHint {
  className?: string
  text?: string
  dataQsId?: string
}

/**
 * DO-13065: notice shown in the send-mail masks while the sender's address is unverified — the API
 * refuses to send (403 `email: NOT_CONFIRMED`), so the mask says so up front and offers the DOI modal.
 * Same visual pattern as `recipient-email-input/own-email-restriction.tsx`.
 */
const EmailNotConfirmedHint = (props: IEmailNotConfirmedHint) => {
  const {
    className,
    text = lang.confirmEmail.sendEmailBlocked,
    dataQsId = 'send-email-not-confirmed-hint',
  } = props
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)} role='status' data-qs-id={dataQsId}>
      <WarningAmberRoundedIcon fontSize='medium' color='warning' />
      <div>
        {text}
        <a onClick={() => openConfirmEmailModal()} data-qs-id={`${dataQsId}-verify`}>
          {lang.confirmEmail.verifyNow}
        </a>
      </div>
    </div>
  )
}

export default EmailNotConfirmedHint
